var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('div',{staticClass:"img-wrap"}),_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"desktop-logo",attrs:{"src":"/img/swampum-logo.png","width":"144","height":"36","alt":"Swampum"}}),_c('img',{staticClass:"mobile-logo",attrs:{"src":"/img/swampum-polygon.png","width":"48","height":"40","alt":"Swampum"}})])])
}]

export { render, staticRenderFns }